import React, { useState, useEffect } from "react";
import "../account-details/account-details.scss";
import AddressImg from "../../assets/accounts/address.svg";
import InfoImg from "../../assets/accounts/info.svg";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from "react-accessible-accordion";
import PageHeader from "../../components/table/pageHeader/PageHeader";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import { getNameFirstLetter, numberFormat } from "../../utils/helper";
import { useNavigate, useParams } from "react-router-dom";
import FMILeads from "../../assets/sidebar/dealerPortal/FMILeads";
import AdditionInfo from "../../assets/sidebar/dealerPortal/AdditionInfo";
import AdditImg from "../../assets/orders/additional.svg";
// import InfoVector from "../../assets/InfoVector";
import useLead from "../../controller/lead-controller";

const FmiLeadsDetails = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { leadDetail, errMsg, isLoading, getLeadDetails } = useLead();
  const [isLoader, setIsLoader] = useState(false);
  const [leadInfo, setLeadInfo] = useState({});
  const [openAcc, setOpenAcc] = useState(["0", "1", "2", "3", "4"]);

  useEffect(() => {
    getLeadDetails(params?.flid);
  }, []);

  useEffect(() => {
    setLeadInfo(leadDetail);
  }, [leadDetail]);

  useEffect(() => {
    setIsLoader(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (errMsg) {
      toast.error(errMsg);
    }
  }, [errMsg]);

  return (
    <div
      className={`accounts-container h-full flex flex-col overflow-y-auto ${
        isLoader ? "mt-2 -mt-[70px]" : ""
      }`}
    >
      {isLoader ? (
        <div className="flex md:h-full h-[calc(100%_-_100px)] justify-center align-center">
          <Loader />
        </div>
      ) : (
        <>
          <PageHeader
            svg={<FMILeads color={"white"} width="24" height="24" />}
            text="FMI Leads"
            subTitle={leadInfo?.leadName}
            isBackBtn={true}
            onBackClick={() => navigate("/fmi-leads")}
          />
          <div className="accordianWrapper">
            <Accordion
              allowMultipleExpanded={true}
              allowZeroExpanded={true}
              preExpanded={["0", "1", "2", "3", "4"]}
              onChange={(item) => setOpenAcc(item)}
            >
              <AccordionItem uuid={"0"} className="accItem mb-4">
                <AccordionItemHeading>
                  <AccordionItemButton
                    className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center ${
                      openAcc.includes("0")
                        ? "md:rounded-t-lg"
                        : "md:rounded-lg"
                    }`}
                  >
                    <div className=" flex flex-row font-semibold md:text-[22px] text-base accTitle">
                      <img src={InfoImg} alt="infoImg" className="mr-2" />
                      Information
                    </div>
                    <AccordionItemState>
                      {({ expanded }) =>
                        expanded ? (
                          <div className="accIconOpen inline-block mr-3" />
                        ) : (
                          <div className="accIconClose inline-block mr-3 rotate-45" />
                        )
                      }
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="bg-white-100 accPanel grid md:rounded-b-lg py-5 px-4">
                    <div className="grid md:grid-cols-2 md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Name
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {leadInfo?.leadName}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Owner
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm">
                          <div className="flex  flex-row items-center md:justify-start justify-end userData">
                            {/* <img
                          src={leadInfo?.accOwnerImg}
                          alt="user"
                          className="rounded-full mr-2"
                        /> */}
                            {leadInfo?.ownerName && (
                              <div className="rounded-full bg-black mr-2 flex justify-center items-center">
                                {getNameFirstLetter(leadInfo?.ownerName)}
                              </div>
                            )}
                            {leadInfo?.ownerName}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2 md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Status
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end text-primary">
                          <span className="text-primary">
                            {leadInfo?.status}
                          </span>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Company
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {leadInfo?.company}
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2 md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Email
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {leadInfo?.email}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Lead Type
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {leadInfo?.leadType}
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2  md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Phone
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {leadInfo?.phone}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Lead Sub Type
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {leadInfo?.leadSubType}
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2 md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base flex items-center">
                          Purchase Pattern
                          {/* <InfoVector className="ms-2" /> */}
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {leadInfo?.purchasePattern}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Purchasing Structure
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {leadInfo?.purchasingStructure}
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2 md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          GST No.
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {leadInfo?.gstNo}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Pan No.
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {leadInfo?.panNo}
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2 md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Unqualified (Reason Codes)
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {leadInfo?.unqualifiedReasonCodes}
                        </div>
                      </div>
                      {leadInfo?.regdOffice ? (
                        <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3">
                          <div className="fieldName font-normal md:text-lg text-base">
                            Registered office
                          </div>
                          <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                            {leadInfo?.regdOffice}
                          </div>
                        </div>
                      ) : null}
                    </div>
                    <div className="grid md:grid-cols-2">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Mobile Phone
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {leadInfo?.mobilePhone}
                        </div>
                      </div>
                      {/* <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base flex items-center">
                          Industry
                          {/* <InfoVector className="ms-2" /> *
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {leadInfo?.industry}
                        </div>
                      </div> */}
                    </div>
                  </div>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem uuid={"1"} className="accItem mb-4">
                <AccordionItemHeading>
                  <AccordionItemButton
                    className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center ${
                      openAcc.includes("1")
                        ? "md:rounded-t-lg"
                        : "md:rounded-lg"
                    }`}
                  >
                    <div className=" flex flex-row font-semibold md:text-[22px] text-base accTitle">
                      <img src={InfoImg} alt="infoImg" className="mr-2" />
                      Commercial Terms Information
                    </div>
                    <AccordionItemState>
                      {({ expanded }) =>
                        expanded ? (
                          <div className="accIconOpen inline-block mr-3" />
                        ) : (
                          <div className="accIconClose inline-block mr-3 rotate-45" />
                        )
                      }
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="bg-white-100 accPanel grid md:rounded-b-lg py-5 px-4">
                    <div className="grid md:grid-cols-2 md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Measuring Tools Discount
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {leadInfo?.measuringToolsDiscount}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Credit Limit
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm">
                          <div className="flex flex-row items-center md:justify-start justify-end">
                            {numberFormat(leadInfo?.creditLimit)}
                            {/* currencySign: "INR" */}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2 md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Hand Tools Discount
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end text-primary">
                          <span className="text-primary">
                            {leadInfo?.handToolsDiscount}
                          </span>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Payment Terms
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {leadInfo?.paymentTerms}
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base flex items-center">
                          Selling Discount
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {leadInfo?.sellingDiscount}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Price List (Power Tools)
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {leadInfo?.priceList}
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem uuid={"2"} className="accItem mb-4">
                <AccordionItemHeading>
                  <AccordionItemButton
                    className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center ${
                      openAcc.includes("2")
                        ? "md:rounded-t-lg"
                        : "md:rounded-lg"
                    }`}
                  >
                    <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                      <img src={AddressImg} alt="infoImg" className="mr-2" />
                      Address Information
                    </div>
                    <AccordionItemState>
                      {({ expanded }) =>
                        expanded ? (
                          <div className="accIconOpen inline-block mr-3" />
                        ) : (
                          <div className="accIconClose inline-block mr-3 rotate-45" />
                        )
                      }
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="bg-white-100 accPanel grid md:rounded-b-lg py-5 px-4">
                    <div className="grid md:grid-cols-2">
                      <div className="grid md:grid-cols-2">
                        <div className="md:mr-10">
                          <div className="fieldDetails font-medium md:text-base text-sm">
                            <div className="flex flex-row rounded-lg p-4 addressData">
                              {leadInfo?.street},<br />
                              {leadInfo?.city}, {leadInfo?.postalCode}
                              ,
                              <br />
                              {leadInfo?.state},<br />
                              {leadInfo?.country}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem uuid={"3"} className="accItem mb-4">
                <AccordionItemHeading>
                  <AccordionItemButton
                    className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center ${
                      openAcc.includes("3")
                        ? "md:rounded-t-lg"
                        : "md:rounded-lg"
                    }`}
                  >
                    <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                      <span className="mr-2">
                        <AdditionInfo />
                      </span>
                      Additional Information
                    </div>
                    <AccordionItemState>
                      {({ expanded }) =>
                        expanded ? (
                          <div className="accIconOpen inline-block mr-3" />
                        ) : (
                          <div className="accIconClose inline-block mr-3 rotate-45" />
                        )
                      }
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="bg-white-100 accPanel grid md:rounded-b-lg py-5 px-4">
                    <div className="grid md:grid-cols-4 grid-cols-2 fieldWrapper md:pb-2 pb-2 pl-0 px-3">
                      <div className="fieldName font-normal md:text-lg text-base">
                        Description
                      </div>
                      <div
                        className="fieldDetails md:col-span-3 font-medium md:text-base text-sm md:text-left text-end"
                        dangerouslySetInnerHTML={{
                          __html: leadInfo?.description,
                        }}
                      />
                    </div>
                  </div>
                </AccordionItemPanel>
              </AccordionItem>
              {leadInfo?.questionnaire?.length > 0 ? (
                <AccordionItem uuid={"4"} className="accItem mb-4">
                  <AccordionItemHeading>
                    <AccordionItemButton
                      className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center ${
                        openAcc.includes("4")
                          ? "md:rounded-t-lg"
                          : "md:rounded-lg"
                      }`}
                    >
                      <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                        <img src={AdditImg} alt="SystemImg" className="mr-2" />
                        Questionnaire
                      </div>
                      <AccordionItemState>
                        {({ expanded }) =>
                          expanded ? (
                            <div className="accIconOpen inline-block mr-3" />
                          ) : (
                            <div className="accIconClose inline-block mr-3 rotate-45" />
                          )
                        }
                      </AccordionItemState>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="bg-white-100 accPanel grid md:rounded-b-lg py-5 px-4">
                      {leadInfo?.questionnaire
                        ?.sort((a, b) => a.questionNo - b.questionNo)
                        ?.map((dt2, i) => (
                          <React.Fragment key={i}>
                            <div
                              className={`font-semibold text-sm accTitle ${
                                i === 0 ? "" : "mt-5"
                              }`}
                            >
                              {dt2?.questionNo}. {dt2?.question}
                            </div>
                            <div
                              className="accPanel pt-2 md:px-4 fieldName font-normal text-sm"
                              dangerouslySetInnerHTML={{
                                __html: dt2?.answer,
                              }}
                            />
                          </React.Fragment>
                        ))}
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>
              ) : null}
            </Accordion>
          </div>
        </>
      )}
    </div>
  );
};

export default FmiLeadsDetails;
